import { render, staticRenderFns } from "./repaymentguide.vue?vue&type=template&id=5ca5c5a6&scoped=true&"
import script from "./repaymentguide.vue?vue&type=script&lang=js&"
export * from "./repaymentguide.vue?vue&type=script&lang=js&"
import style0 from "./repaymentguide.vue?vue&type=style&index=0&id=5ca5c5a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca5c5a6",
  null
  
)

export default component.exports